// Import model
import { ReportDocumentTemplate } from '../models/ReportDocumentTemplate';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ReportDocumentTemplate - handles JSON serialization and deserialization with type validation
 */
export class ReportDocumentTemplateSerializer {
  /**
   * Deserializes a JSON string into a ReportDocumentTemplate instance
   */
  static deserialize(json: string): ReportDocumentTemplate {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ReportDocumentTemplate instance
   */
  static fromObject(obj: any): ReportDocumentTemplate {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ReportDocumentTemplate');
    }


    const instance: ReportDocumentTemplate = {
      contentType: obj['ContentType'] as string | undefined,
      storedProcedures: obj['StoredProcedures'] as any | undefined,
      inputs: obj['Inputs'] as string | undefined,
      template: obj['Template'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedOn: obj['LastModifiedOn'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ReportDocumentTemplate instances
   */
  static deserializeArray(json: string): ReportDocumentTemplate[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ReportDocumentTemplate instance to a JSON string
   */
  static serialize(instance: ReportDocumentTemplate): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ReportDocumentTemplate instance to a plain object
   */
  static toObject(instance: ReportDocumentTemplate): any {
    return {
      'ContentType': instance.contentType,
      'StoredProcedures': instance.storedProcedures,
      'Inputs': instance.inputs,
      'Template': instance.template,
      'isActive': instance.isActive,
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'LastModifiedOn': instance.lastModifiedOn,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
    };
  }

  /**
   * Serializes an array of ReportDocumentTemplate instances to a JSON string
   */
  static serializeArray(instances: ReportDocumentTemplate[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
